import { OnboardingPeriodType } from '@zorro/clients';
import { APP_ROUTES } from '@zorro/common-utils';
import { $enum } from 'ts-enum-util';

export function createImpersonationSession(employeeId: string, route: string) {
  const baseUrl = process.env.NEXT_PUBLIC_APP_BASE_URL;

  const url = new URL(route, baseUrl);

  url.searchParams.set('impersonatedEmployeeId', employeeId);

  window.open(url.toString(), '_blank');
}

export const getImpersonationRoute = (
  onboardingPeriodType: OnboardingPeriodType
) =>
  $enum.mapValue(onboardingPeriodType).with<string>({
    [OnboardingPeriodType.REPORTING]: APP_ROUTES.REPORT(),
    [OnboardingPeriodType.SHOPPING]: APP_ROUTES.PERSONALIZED_ALLOWANCE(),
  });
